import { Link } from '@farol-ds/react'
import { COMPONENT_NAME } from '@jusbrasil-web/shared-ga4-events'
import { useEffect } from 'react'

import errorImgSrc from '../../../assets/cpf-validation/error.svg'
import { CLICK_EVENT_PROPS, COMPONENT_RENDER_EVENT_PROPS, GA4EventHandlers } from '../../../hooks'
import { SUPPORT_CONTACT_URL } from '../constants'
import { Steps } from '../enums'
import { DocumentStaticStep } from './document-static-step'

interface IdentityErrorProps {
  gA4EventHandlers?: GA4EventHandlers
}

export function IdentityError(props: IdentityErrorProps) {
  const { gA4EventHandlers } = props

  useEffect(() => {
    gA4EventHandlers?.sendComponentRender({
      componentClass: null,
      componentName: COMPONENT_NAME.DOCUMENT_VALIDATION,
      renders: COMPONENT_RENDER_EVENT_PROPS.IDENTITY_ERROR,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DocumentStaticStep
      testId="identity-error-step"
      imageSrc={errorImgSrc}
      title="Identidade não pôde ser verificada"
      bodyText={
        <>
          Por favor, revise suas informações ou entre em{' '}
          <Link
            href={SUPPORT_CONTACT_URL}
            target="_blank"
            onClick={() => gA4EventHandlers?.sendClick(CLICK_EVENT_PROPS.IDENTITY_ERROR)}
          >
            contato com o suporte
          </Link>
          .
        </>
      }
      action={{
        nextStep: Steps.VALIDATE_DOCUMENT,
        label: 'Revisar Informações',
      }}
      onLoadEvent={{
        name: 'UserAccount.IdValidationFailedViewed',
        data: { type: 'DocumentValidationError' },
      }}
    />
  )
}
